export default {"src":"/_next/static/media/westIndies.35c014cf.svg","height":36,"width":36};